import axios from "axios";
/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import "vue-resize/dist/vue-resize.css";
import VueResize from "vue-resize";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import Argon from "./plugins/argon-kit";
import "./registerServiceWorker";
// antd 按需引入（替代全量 Vue.use(Antd)，只打包用到的组件）
// 主组件：install 已注册自身；子组件（form-item/input-password/menu-item 等）在下方手动注册
import Button from "ant-design-vue/es/button";
import Col from "ant-design-vue/es/col";
import Row from "ant-design-vue/es/row";
import FormModel from "ant-design-vue/es/form-model";
import FormModelItem from "ant-design-vue/es/form-model/FormItem";
import Form from "ant-design-vue/es/form";
import FormItem from "ant-design-vue/es/form/FormItem";
import Input from "ant-design-vue/es/input";
import InputPassword from "ant-design-vue/es/input/Password";
import InputSearch from "ant-design-vue/es/input/Search";
import TextArea from "ant-design-vue/es/input/TextArea";
import Menu from "ant-design-vue/es/menu";
import MenuItem from "ant-design-vue/es/menu/MenuItem";
import SubMenu from "ant-design-vue/es/menu/SubMenu";
import Select from "ant-design-vue/es/select";
import Radio from "ant-design-vue/es/radio";
import RadioGroup from "ant-design-vue/es/radio/Group";
import Checkbox from "ant-design-vue/es/checkbox";
import Table from "ant-design-vue/es/table";
import Tag from "ant-design-vue/es/tag";
import Upload from "ant-design-vue/es/upload";
import Modal from "ant-design-vue/es/modal";
import ConfigProvider from "ant-design-vue/es/config-provider";
import Pagination from "ant-design-vue/es/pagination";
import InputNumber from "ant-design-vue/es/input-number";
import Descriptions from "ant-design-vue/es/descriptions";
import TreeSelect from "ant-design-vue/es/tree-select";
import Tree from "ant-design-vue/es/tree";
import Spin from "ant-design-vue/es/spin";
import Dropdown from "ant-design-vue/es/dropdown";
import AntBreadcrumb from "ant-design-vue/es/breadcrumb";
import Empty from "ant-design-vue/es/empty";
import message from "ant-design-vue/es/message";

// 图标：只引入模板实际用到的 10 个图标（antd-vue 默认会注册全部 ~780 个，占 ~700KB）
import CheckCircleOutlined from "@ant-design/icons-vue/lib/icons/CheckCircleOutlined";
import CopyOutlined from "@ant-design/icons-vue/lib/icons/CopyOutlined";
import LeftOutlined from "@ant-design/icons-vue/lib/icons/LeftOutlined";
import LockOutlined from "@ant-design/icons-vue/lib/icons/LockOutlined";
import MailOutlined from "@ant-design/icons-vue/lib/icons/MailOutlined";
import MobileOutlined from "@ant-design/icons-vue/lib/icons/MobileOutlined";
import PlusOutlined from "@ant-design/icons-vue/lib/icons/PlusOutlined";
import SafetyCertificateOutlined from "@ant-design/icons-vue/lib/icons/SafetyCertificateOutlined";
import TeamOutlined from "@ant-design/icons-vue/lib/icons/TeamOutlined";
import UploadOutlined from "@ant-design/icons-vue/lib/icons/UploadOutlined";

import "ant-design-vue/dist/antd.css";
import "./index.css";

import { i18n } from "./i18n/index"; //国际化
import Breadcrumb from "./layout/Breadcrumb";

import moment from "moment";

import VueClipboard from "vue-clipboard2";
import { EventBus } from "./assets/event-bus";
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
// antd 按需注册（原 Vue.use(Antd) 全量注册）
Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.use(FormModel);
Vue.use(Form);
Vue.use(Input);
Vue.use(Menu);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Table);
Vue.use(Tag);
Vue.use(Upload);
Vue.use(Modal);
Vue.use(ConfigProvider);
Vue.use(Pagination);
Vue.use(InputNumber);
Vue.use(Descriptions);
Vue.use(TreeSelect);
Vue.use(Tree);
Vue.use(Spin);
Vue.use(Dropdown);
Vue.use(AntBreadcrumb);
Vue.use(Empty);
// antd 子组件：主组件 install 不会自动注册，需手动补（表单/输入/菜单/下拉等核心标签）
Vue.component("a-form-model-item", FormModelItem);
Vue.component("a-form-item", FormItem);
Vue.component("a-input-password", InputPassword);
Vue.component("a-input-search", InputSearch);
Vue.component("a-textarea", TextArea);
Vue.component("a-menu-item", MenuItem);
Vue.component("a-sub-menu", SubMenu);
Vue.component("a-select-option", Select.Option);
Vue.component("a-radio-group", RadioGroup);
// message 无 install，手动挂原型（全量包里由 lib/index.js 注入）
Vue.prototype.$message = message;

// 自定义 a-icon：仅注册模板用到的 10 个图标，避免全量图标（~780 个）进包
const AIcon = {
	name: "AIcon",
	props: { type: { type: String, default: "" } },
	render(h) {
		const icons = {
			"check-circle": CheckCircleOutlined,
			copy: CopyOutlined,
			left: LeftOutlined,
			lock: LockOutlined,
			mail: MailOutlined,
			mobile: MobileOutlined,
			plus: PlusOutlined,
			"safety-certificate": SafetyCertificateOutlined,
			team: TeamOutlined,
			upload: UploadOutlined,
		};
		const icon = icons[this.type];
		if (!icon) return null;
		return h(icon, { attrs: this.$attrs, on: this.$listeners });
	},
};
Vue.component("a-icon", AIcon);
Vue.use(VueResize);
Vue.use(VueClipboard);

// Vue.use(Argon);
Vue.component("Breadcrumb", Breadcrumb);

// const base_url = 'http://27.191.44.128:18080/prod-api'
//const base_url = "http://localhost:8081/prod-api";
// export const base_url = 'http://8.140.17.109:8083/prod-api' // 正式版地址
export const base_url = "https://www.wirechina.net/prod-api"; // 正式版地址
//export const base_url = "http://192.168.3.99:10000/prod-api"; // 正式版地址
//export const base_url = "http://localhost:8081/prod-api"; // local server
// export const base_url = "http://takelamagan.natapp1.cc/prod-api"; // local server

// const base_url = 'http://39.100.81.29:58082/prod-api/'
// const base_url = 'http://27.191.44.128:18080/prod-api/'

// 将 apiUrls 添加到 Vue 的原型上
Vue.prototype.$baseurl = base_url;

const instance = axios.create({
	baseURL: base_url, // 替换为你的API基础URL
	timeout: 30000, // 设置请求超时时间
});

instance.interceptors.request.use((config) => {
	config.headers["token"] = localStorage.getItem("token")
		? localStorage.getItem("token")
		: null;
	config.headers["language"] = localStorage.getItem("lang") || "ZH";
	return config;
});
instance.interceptors.response.use(
	(response) => {
		if (
			response.data.code === 510 &&
			response.data.message === "没有权限，请联系管理员授权"
		) {
			console.log("token已失效，请重新登录");
			EventBus.$emit("token-invalid", true);
			localStorage.removeItem("token");
			localStorage.removeItem("userIdentity");
			router.push("/");
		}
		return response;
	},
	(error) => {
		return Promise.reject(error);
	},
);

// 检测浏览器语言并设置默认语言
if (typeof navigator !== "undefined" && !localStorage.getItem("lang")) {
  const browserLang = navigator.language || navigator.userLanguage;
  const lang = browserLang && browserLang.startsWith('zh') ? "ZH" : "EN";
  localStorage.setItem("lang", lang);
}
Vue.prototype.$language = (typeof localStorage !== "undefined" && localStorage.getItem("lang")) || "ZH";
Vue.prototype.$axios = instance;

// 预渲染钩子：仅在浏览器端执行，把 i18n 语言写进 html 根节点，
// 这样 prerender-spa-plugin + puppeteer 才能渲染出对应语种的正文。
if (typeof window !== "undefined") {
  document.documentElement.setAttribute("lang", Vue.prototype.$language === "EN" ? "en" : "zh-CN");

  // 反注册旧版 Service Worker，避免之前的 SW 缓存与新版 prerender 产物冲突，
  // 导致 banner 等区域用旧 CSS/JS 渲染出错误的内联尺寸。
  // 保留 registerServiceWorker 的注册是为了后面 vue.config.js pwa 配置关闭后再启用。
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => {
        // 只清掉 sw 脚本路径以 /service-worker.js 结尾的（即本项目注册的）
        // 如果你有其他子应用共享域名，可放开这个过滤
        try {
          if (
            r.active &&
            r.active.scriptURL &&
            r.active.scriptURL.indexOf("/service-worker.js") !== -1
          ) {
            r.unregister().catch(() => {});
          }
        } catch (e) {}
      });
    }).catch(() => {});
  }
}

const AppVue = new Vue({
	router,
	i18n, //使用国际化
	render: (h) => h(App),
	mounted() {
		// 通知 prerender-spa-plugin：当前页面已渲染完毕，可以抓取 HTML 了
		// 仅在真实浏览器（puppeteer 渲染）中调用
		if (typeof window !== "undefined") {
			window.__PRERENDER_COMPLETE__ = true;
		}
	},
}).$mount("#app");
